import { Button, customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const WidgetContentWrapper = styled.div`
  ${customScrollMinimal};
  padding: 8px 16px;
  overflow-y: scroll;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 16px;
  padding: 0 8px;
`;

export const StyledButton = styled(Button)`
  width: 155px;
`;
